export default __webpack_public_path__ + "static/media/logo.8eb5a23f.svg";